import React from 'react';
import styled from 'styled-components';
import { IForecastCard } from '../../common/types';
import { CommonContainerStyle } from '../styles';
import { ConditionsDescription } from './conditionsDescription';
import { ConditionsWeatherInfo } from './conditionsWeatherInfo';

type HourCardConditionsProps = Pick<IForecastCard, 'description' | 'temperature' | 'iconCode'| 'feelsLike'>;

export const HourCardConditions = ({ temperature, description, iconCode, feelsLike }: HourCardConditionsProps) => {
    return (
        <Container>
            <ConditionsWeatherInfo temperature={temperature} iconCode={iconCode} feelsLike={feelsLike} />
            <ConditionsDescription description={description} />
        </Container>
    );
};

const Container = styled.div`
    ${CommonContainerStyle}
    height: 142px;
    padding: 15px 15px 0 15px;
`;